module.exports = __webpack_public_path__ + "img/left.badacc6c.jpg";